/**
 * CRA inlines env at build time. Supports both names: codebase uses REACT_APP_API_BASE_URL;
 * README historically documented REACT_APP_API_URL.
 */
export default function getApiBaseUrl() {
  const raw = process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_API_URL || '';
  let base = typeof raw === 'string' ? raw.trim() : '';
  if (base && !base.endsWith('/')) {
    base = `${base}/`;
  }
  return base;
}
